import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons } from '@/design_system/Footer';
import {
  canBeCreatedBy,
  canReceptionBeVerifiedBy,
  ShipmentWithRelations,
  useCompleteHandover,
  useCompleteInTransit,
} from '@/models/shipment';
import { useCurrentSession } from '@/services/auth';

const HandoverAction = ({
  shipment,
  onHandOverDone,
}: {
  shipment: ShipmentWithRelations;
  onHandOverDone: () => void;
}) => {
  const {
    mutateAsync: completeHandover,
    isPending: isPendingCompleteHandover,
    isSuccess: isSuccessCompleteHandover,
  } = useCompleteHandover();
  const {
    mutateAsync: completeInTransit,
    isPending: isPendingCompleteInTransit,
    isSuccess: isSuccessCompleteInTransit,
  } = useCompleteInTransit();

  const { currentSession } = useCurrentSession();

  const canCreateShipment = canBeCreatedBy(shipment, currentSession);
  const canVerifyReception = canReceptionBeVerifiedBy(shipment, currentSession);

  if (canCreateShipment && shipment.handover) {
    return (
      <Footer>
        <FooterButtons>
          <Button
            variant="primary"
            onPress={async () => {
              await completeHandover(shipment.id);
              onHandOverDone();
            }}
            isLoading={isPendingCompleteHandover || isSuccessCompleteHandover}
          >
            {shipment.handover === 'dropoff' && (
              <Trans id="shipment.drop-off-done">Mark package drop-off as done</Trans>
            )}
            {(shipment.handover === 'pickup' || shipment.handover === 'automatic_pickup') && (
              <Trans id="shipment.pickup-done">Mark package pickup as done</Trans>
            )}
          </Button>
        </FooterButtons>
      </Footer>
    );
  }

  if (canVerifyReception) {
    return (
      <Footer>
        <FooterButtons>
          <Button
            variant="primary"
            onPress={() => {
              completeInTransit(shipment.id);
            }}
            isLoading={isPendingCompleteInTransit || isSuccessCompleteInTransit}
          >
            <Trans id="shipment.mark-as-received">Mark as received</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    );
  }

  return null;
};

export default HandoverAction;
